'use client';

import { useT } from 'next-i18next/client';

export default function GlobalError({
  error,
  reset,
}: {
  error: { message?: string };
  reset: () => void;
}) {
  const { t } = useT('system');
  return (
    <html lang="en">
      <body>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            flexDirection: 'column',
          }}
        >
          <h1 style={{ fontSize: '3rem', color: 'red' }}>{t('error.title')}</h1>
          <p>{error?.message || t('error.message')}</p>
          <button onClick={reset}>{t('error.tryAgain')}</button>
        </div>
      </body>
    </html>
  );
}

